module.exports = __webpack_public_path__ + "static/how_to_notification-77f61443b0ce0e75869595b187447c9d.png";